import { useContext } from 'react';
import { ContextoUsuario } from '../../contextos/usuario/ProvedorUsuario';
import { Icone } from '../Icone';
import { Conteiner, IconeLink, Nome } from './styles';

export const MenuLateral = () => {
  const { usuario } = useContext(ContextoUsuario);

  return (
    <Conteiner>
      <IconeLink to='/home'>
        <Icone nome='FaHome' tamanho={20} />
        <Nome>Início</Nome>
      </IconeLink>
      <IconeLink to='/solicitacoes'>
        <Icone nome='FaWpforms' tamanho={20} />
        <Nome>Solicitações</Nome>
      </IconeLink>
      {usuario.perfil === 'Administrador' && (
        <>
          <IconeLink to='/usuario'>
            <Icone nome='FaUser' tamanho={20} />
            <Nome>Usuários</Nome>
          </IconeLink>
          <IconeLink to='/instituicao'>
            <Icone nome='FaSchool' tamanho={20} />
            <Nome>Instituições</Nome>
          </IconeLink>
        </>
      )}
    </Conteiner>
  );
};
